function getOrdinal(number) {
    // Determine the suffix for the ordinal number based on the last digit and the last two digits of the number
    const j = number % 10;
    const k = number % 100;
    if (j === 1 && k !== 11) {
        return number + "st";
    }
    if (j === 2 && k !== 12) {
        return number + "nd";
    }
    if (j === 3 && k !== 13) {
        return number + "rd";
    }
    return number + "th";
}

function clearCustomValidity(form) {
    // Clear any custom validity messages for specific form fields
    document.getElementById("ctx-schedule-hourOfDay").setCustomValidity("");
    document.getElementById("ctx-schedule-ampm").setCustomValidity("");
    document.getElementById("ctx-schedule-dayOfWeek").setCustomValidity("");
    document.getElementById("ctx-schedule-dayOfMonth").setCustomValidity("");
    form.reportValidity();
}

document.addEventListener("DOMContentLoaded", function () {
    // Initialize variables for the schedule modal and its form elements
    const ctxScheduleModal = document.getElementById("ctxScheduleModal");
    if (!ctxScheduleModal){return;}
    const ctxScheduleOffcanvas = new bootstrap.Offcanvas(ctxScheduleModal);
    const ctxScheduleForm = document.getElementById("ctxScheduleForm");
    const frequency = document.getElementById("ctx-schedule-frequency");
    const subFrequencyContainers = {
        daily: document.getElementById("ctx-schedule-subFrequencyDaily"),
        weekly: document.getElementById("ctx-schedule-subFrequencyWeekly"),
        monthly: document.getElementById("ctx-schedule-subFrequencyMonthly"),
    };
    const startDatetime = document.getElementById("ctx-schedule-startDatetime");
    const endDatetime = document.getElementById("ctx-schedule-endDatetime");
    const endDatetimeContainer = document.getElementById(
        "ctx-schedule-endDatetimeContainer"
    );
    const endContainer = document.getElementById("ctx-schedule-endContainer");
    const runForever = document.getElementById("ctx-schedule-runForever");
    const startDatetimeLabel = document.querySelector(
        "#ctx-schedule-startDatetimeLabel"
    );
    const ctxScheduleSummaryContainer = document.getElementById(
        "ctx-schedule-summary-container"
    );
    const ctxFieldSchedule = document.getElementById("ctx-field-schedule");
    const ctxScheduleClear = document.querySelector("#ctx-schedule-clear");
    const ctxScheduleSummary = document.getElementById("ctx-schedule-summary");

    frequency.addEventListener("change", function () {
        // Hide all sub-frequency containers initially
        Object.values(subFrequencyContainers).forEach(
            (container) => (container.style.display = "none")
        );
        // Display the appropriate sub-frequency container based on the selected frequency
        if (frequency.value && subFrequencyContainers[frequency.value]) {
            subFrequencyContainers[frequency.value].style.display = "block";
        }
        // Adjust label and container visibility based on the selected frequency
        if (frequency.value === "once") {
            startDatetimeLabel.textContent = "Date";
            endContainer.style.display = "none";
        } else {
            startDatetimeLabel.textContent = "Start Date";
            endContainer.style.display = "block";
            if (frequency.value) {
                subFrequencyContainers.daily.style.display = "block";
            }
        }
        clearCustomValidity(ctxScheduleForm);
    });

    runForever.addEventListener("change", function () {
        // Toggle the visibility and requirements of the end date/time fields based on the "run forever" checkbox
        if (runForever.checked) {
            endDatetime.disabled = true;
            endDatetime.removeAttribute("required");
            endDatetime.value = "";
            endDatetimeContainer.style.display = "none";
        } else {
            endDatetime.disabled = false;
            endDatetime.setAttribute("required", "required");
            endDatetimeContainer.style.display = "block";
        }
    });

    startDatetime.addEventListener("change", function () {
        // Validate that the end date/time is not before the start date/time
        if (
            endDatetime.value &&
            new Date(endDatetime.value) < new Date(startDatetime.value)
        ) {
            endDatetime.setCustomValidity(
                "End DateTime must be greater than or equal to Start DateTime."
            );
        } else {
            endDatetime.setCustomValidity("");
        }
    });

    endDatetime.addEventListener("change", function () {
        // Validate that the end date/time is not before the start date/time
        if (new Date(endDatetime.value) < new Date(startDatetime.value)) {
            endDatetime.setCustomValidity(
                "End DateTime must be greater than or equal to Start DateTime."
            );
        } else {
            endDatetime.setCustomValidity("");
        }
    });

    // Initialize tooltips for elements with the "data-bs-toggle=tooltip" attribute
    const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltips.forEach((t) => new bootstrap.Tooltip(t));

    ctxScheduleForm.addEventListener("change", function (event) {
        clearCustomValidity(ctxScheduleForm);
    });

    ctxScheduleForm.addEventListener("submit", function (event) {
        try {
            const action = ctxScheduleForm.getAttribute('action');
            if (!action) {
                event.preventDefault();
            }

            const frequencyValue = frequency.value;
            let subFrequencyText = "only";
            let valid = true;

            // Validate and set sub-frequency text for non-"once" frequencies
            if (frequencyValue && frequencyValue !== "once") {
                const hour = document.getElementById("ctx-schedule-hourOfDay").value;
                const ampm = document.getElementById("ctx-schedule-ampm").value;
                if (!hour || !ampm) {
                    if (!hour) {
                        document
                            .getElementById("ctx-schedule-hourOfDay")
                            .setCustomValidity(
                                "Please specify the hour of the day."
                            );
                    }
                    if (!ampm) {
                        document
                            .getElementById("ctx-schedule-ampm")
                            .setCustomValidity("Please specify AM or PM.");
                    }
                    valid = false;
                } else {
                    document
                        .getElementById("ctx-schedule-hourOfDay")
                        .setCustomValidity("");
                    document
                        .getElementById("ctx-schedule-ampm")
                        .setCustomValidity("");
                    subFrequencyText = `at ${hour} ${ampm}${
                        frequencyValue === "daily" ? " every day" : ""
                    }`;
                }
            }

            // Additional validation for weekly frequency
            if (frequencyValue === "weekly") {
                const days = Array.from(
                    document.getElementById("ctx-schedule-dayOfWeek").selectedOptions
                )
                    .map((option) => option.text)
                    .join(", ");
                if (days.length === 0) {
                    document
                        .getElementById("ctx-schedule-dayOfWeek")
                        .setCustomValidity(
                            "Please select at least one day of the week."
                        );
                    valid = false;
                } else {
                    document
                        .getElementById("ctx-schedule-dayOfWeek")
                        .setCustomValidity("");
                    subFrequencyText = `on ${days} ${subFrequencyText}`;
                }
                // Additional validation for monthly frequency
            } else if (frequencyValue === "monthly") {
                const dayOfMonth =
                    document.getElementById("ctx-schedule-dayOfMonth").value;
                if (!dayOfMonth) {
                    document
                        .getElementById("ctx-schedule-dayOfMonth")
                        .setCustomValidity("Please specify the day of the month.");
                    valid = false;
                } else {
                    document
                        .getElementById("ctx-schedule-dayOfMonth")
                        .setCustomValidity("");
                    subFrequencyText = `on the ${getOrdinal(
                        dayOfMonth
                    )} of every month ${subFrequencyText}`;
                }
            }

            const startDatetimeValue = new Date(
                document.getElementById("ctx-schedule-startDatetime").value
            );
            const startDatetimeText = `${
                frequency.value === "once" ? "around" : "starting on"
            } ${startDatetimeValue.toLocaleString()}`;

            const runForeverChecked = runForever.checked;
            let endDatetimeText = "";
            // Set end date/time text based on frequency and "run forever" status
            if (
                frequency.value !== "once" &&
                !runForeverChecked &&
                endDatetime.value
            ) {
                const endDatetimeValue = new Date(endDatetime.value);
                endDatetimeText = `and ending on ${endDatetimeValue.toLocaleString()}.`;
            } else if (runForeverChecked) {
                endDatetimeText =
                    frequency.value === "once" ? "" : "and running indefinitely.";
            }

            if (valid) {
                ctxScheduleForm.reportValidity();
                const summary = `This transaction is set to occur ${frequencyValue} ${subFrequencyText}, ${startDatetimeText} ${endDatetimeText}`;
                if (ctxScheduleSummaryContainer) {
                    ctxScheduleSummary.textContent = summary;
                    ctxScheduleSummaryContainer.style.display = "block";

                    const formData = new FormData(event.target);
                    const formObject = {};

                    // Convert form data to a JSON object
                    formData.forEach((value, key) => {
                        formObject[key.replace('[]','')] = (key.endsWith('[]')) ? formData.getAll(key) : value;
                    });

                    const jsonString = JSON.stringify(formObject);
                    console.debug(formObject);
                    // console.debug(formData.getAll());

                    // Save the schedule JSON string to the hidden field
                    ctxFieldSchedule.value = jsonString;

                    // Close the offcanvas
                    ctxScheduleOffcanvas.hide();
                }
            } else {
                ctxScheduleForm.reportValidity();
                event.preventDefault();
            }
        } catch (error) {
            console.error(error);
            event.preventDefault();
        }
    });

    if (ctxScheduleClear) {
        ctxScheduleClear.addEventListener("click", function () {
            // Clear the schedule form and summary
            ctxFieldSchedule.value = "";
            ctxScheduleSummaryContainer.style.display = "none";
            ctxScheduleSummary.textContent = "";
        });
    }
});
